import { render, staticRenderFns } from "./WinnerList.vue?vue&type=template&id=56a4de87&scoped=true&"
import script from "./WinnerList.vue?vue&type=script&lang=js&"
export * from "./WinnerList.vue?vue&type=script&lang=js&"
import style0 from "./WinnerList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./WinnerList.vue?vue&type=style&index=1&id=56a4de87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a4de87",
  null
  
)

export default component.exports